import React from 'react';
import { IconStarFilled } from '@tabler/icons-react';
import { Button } from '@mantine/core';

// --- Data for your clients ---
const clientData = [
  {
    name: 'Sarvin Appliances',
    websiteUrl: 'https://sarvinindia.com/', 
    feedback: "Jeevan was instrumental in launching our first D2C e-commerce site, scaling it impressively to over 1000 daily visits. He built a robust MERN backend and a dynamic React UI, significantly boosting dashboard performance. His expertise was invaluable.",
    rating: 5,
    image: '/sarvinAppliances.png', 
    isPrivate: false,
  },
  {
    name: 'Skapa Hospitality',
    websiteUrl: 'https://skapahospitality.in/', 
    feedback: "Jeevan’s optimization work took our site from unstable and invisible to Google to a fast, fully indexed, and high-ranking platform. His precision in backend fixes, SEO setup, and performance tuning has been game-changing.",
    rating: 5,
    image: '/Skapa_hospitality.png', 
    isPrivate: false,
  },
  {
    name: 'Equvinoxis Technologies',
    websiteUrl: '#',
    feedback: "During his internship, Jeevan made significant contributions to our manufacturing RFQ platform. He was responsible for building out the frontend and played a key role in developing backend functionalities with MySQL and Docker. His work was a great asset.",
    rating: 4.5,
    image: '/fallback.png',
    isPrivate: true,
  },
];

// --- A single client card component ---
const ClientCard = ({ client }: { client: typeof clientData[0] }) => {
  return (
    <div 
        data-aos="fade-up" 
        data-aos-duration="800"
        className="w-full md:w-[48%] flex flex-col bg-bgColor border-2 border-primaryColor/50 hover:border-primaryColor rounded-2xl p-6 shadow-[0_0_10px_0_#64FFDA50] hover:shadow-[0_0_20px_0_#64FFDA70] hover:-translate-y-2 transition-all duration-300 ease-in-out"
    >
      <div className="mb-4 rounded-lg overflow-hidden border border-textColor/20">
        <img 
          src={client.image} 
          alt={`${client.name} website screenshot`} 
          className="w-full h-auto object-cover" 
        />
      </div>
      
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-2xl font-bold text-white">{client.name}</h3>
        <div className="flex items-center gap-1 bg-primaryColor/10 px-2 py-1 rounded-full border border-primaryColor/20">
            <span className="text-yellow-400 font-bold text-lg">{client.rating.toFixed(1)}</span>
            <IconStarFilled className="text-yellow-400 w-5 h-5" />
        </div>
      </div>

      <p className="text-textColor text-justify text-sm flex-grow mb-5">
        "{client.feedback}"
      </p>
      
      <Button
        component="a"
        href={client.isPrivate ? undefined : client.websiteUrl}
        target="_blank"
        rel="noopener noreferrer"
        disabled={client.isPrivate}
        fullWidth
        className={client.isPrivate 
          ? "!bg-gray-700 !text-gray-400 cursor-not-allowed" 
          : "!bg-primaryColor !text-bgColor hover:!bg-primaryColor/90"
        }
        variant="filled"
        color="#64FFDA"
      >
        {client.isPrivate ? 'Project is Confidential' : 'Visit Live Site'}
      </Button>
    </div>
  );
};

// --- The main Clients section component ---
const Clients = () => {
  return (
    <div className="px-16 my-20 font-mono md-mx:px-6" id="Clients">
      <h1 className="text-4xl sm-mx:text-3xl xs-mx:text-2xl text-center mb-10 font-bold text-white">
        <span className="text-primaryColor">05.&nbsp;</span>Client Showcase
      </h1>
      <div className="flex flex-wrap justify-center items-stretch gap-8">
        {clientData.map((client, index) => (
          <ClientCard key={index} client={client} />
        ))}
      </div>
    </div>
  );
};

export default Clients;